import * as React from 'react';
import { Modal } from './modal';
import Box from './primitives/Box';
import { H4, Span } from '../typography';
import { ModalButton } from './formElements/applicationFormElements';
import { ApolloError } from 'apollo-client';
import { formatGqlError } from '../utils/helpers';

type Props = {
  message: string | React.ReactNode;
  secondLine?: string;
  confirmButtonText?: string;
  open: boolean;
  heading: string;
  loading?: boolean;
  onClickBack?: () => void;
  onClose: () => void;
  onClickConfirm: () => void;
  error?: ApolloError;
};

const ConfirmationModal: React.FC<Props> = props => {
  const { open, onClose, loading, onClickBack, onClickConfirm, message, confirmButtonText, error } = props;
  return (
    <Modal open={open} onClose={onClose} heading="Confirmation">
      <Box flexDirection="column" width="500px">
        <H4 fontWeight="lighter" mb={4}>
          {message}
        </H4>
        {error && (
          <Span width="100%" textAlign="center" color="error" mb={3}>
            {formatGqlError(error)}
          </Span>
        )}
        <Box pt={4} borderTop="1px solid #f1f7fb" flexDirection="row" alignItems="flex-start" justifyContent="flex-end">
          <ModalButton type="button" onClick={onClickBack} text="Back" bg="coal" mr={4} />
          <ModalButton
            isLoading={loading}
            type="submit"
            onClick={onClickConfirm}
            text={confirmButtonText || 'Confirm'}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal.tsx